export const SET_PAGE_NOT_FOUND = 'SET_PAGE_NOT_FOUND'

export const setPageNotFound = (show: boolean) => ({
  type: SET_PAGE_NOT_FOUND,
  payload: {
    show,
  },
})
